import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LoadingScreen from "../shared/ui/loading/LoadingScreen";
import AppLayout from "../shared/layouts/app/AppLayout";
import { AuthGuard } from "../shared/guards/AuthGuard";
import { ROUTES } from "../core/config";
import { appRoute } from "../shared/utils/router";

const DashboardPage = lazy(
  () => import("../features/dashboard/pages/DashboardPage")
);

const ServicesPage = lazy(
  () => import("../features/services/pages/ServicesPage")
);

const SupportPage = lazy(
  () => import("../features/support/pages/SupportPage")
);

const AppRoutes = () => {
  return (
    <AuthGuard>
      <AppLayout>
        <Suspense fallback={<LoadingScreen text="Chargement..." />}>
          <Routes>
            <Route
              path="/"
              element={
                <Navigate
                  to={appRoute(ROUTES.APP_ROUTES.DASHBOARD)}
                  replace
                />
              }
            />

            <Route
              path={appRoute(ROUTES.APP_ROUTES.DASHBOARD)}
              element={<DashboardPage />}
            />

            <Route
              path={appRoute(ROUTES.APP_ROUTES.SERVICES)}
              element={<ServicesPage />}
            />

            <Route
              path={appRoute(ROUTES.APP_ROUTES.SUPPORT)}
              element={<SupportPage />}
            />
          </Routes>
        </Suspense>
      </AppLayout>
    </AuthGuard>
  );
};

export default AppRoutes;